import {GuideCardSkeleton, GuideCreateButton} from '@/features/guides';

export const GuidesZeroInstalledState = () => {
  return (
    <div className="mx-auto flex size-full max-w-sm flex-col items-start justify-center gap-8">
      <GuideCardSkeleton />
      <div>
        <h1 className="mb-3 text-title-h1">Инструкции</h1>
        <p className="max-w-sm text-paragraph-lg text-text-secondary">
          Начните создавать пошаговые инструкции для приложений
        </p>
      </div>
      <GuideCreateButton menuPlacement="bottom-start" />
    </div>
  );
};
